/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { defaultPaths } from './default-paths';

const repositoryPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  detail: (repositoryId: string) => {
    const repositoryBase = `${base}/${repositoryId}`;

    return {
      ...defaultPaths(repositoryBase),
      repositoryDetail: `${repositoryBase}/detail`,
      tagDetail: (tagId: string) => `${repositoryBase}/tag/${tagId}`,
    };
  },
});

const containerPaths = (base: string) => ({
  ...defaultPaths(base),
  landing: `${base}/landing`,
  quickstart: `${base}/quickstart`,
  repository: repositoryPaths(`${base}/repository`),
  secrets: `${base}/secrets`,
});

export default containerPaths;
